export default __webpack_public_path__ + "static/media/resourceelumnt4.b27dd48a.jpg";